export default __webpack_public_path__ + "static/mapc-fullcolor-192d955d847e7e316d17a7f742b5f0d3.png";